export type DeviceGroup = "jetson" | "others";

export interface DeviceMeta {
  id: string;
  name: string;
  group: DeviceGroup;
}

// Display registry. Alarm wiring (topics, payloads, broker routing) lives on
// the backend in server/auto-alarm.js — keep this list in sync by id only.
// `group` controls which build a device appears in (see VITE_DEVICE_GROUP).
export const devices: DeviceMeta[] = [
  { id: "jetson-kcl", name: "Jetson (kcl)", group: "jetson" },
  { id: "variphi-gpu", name: "Variphi GPU", group: "others" },
  { id: "tatva-04", name: "Tatva 04", group: "others" },
  { id: "tatva-03", name: "Tatva 03", group: "others" },
  { id: "tatva-02", name: "Tatva 02", group: "others" },
  { id: "tatva-01", name: "Tatva 01", group: "others" },
];
